import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Download, Mail } from "lucide-react";

const HelpPage = () => {
  return (
    <div className="grid gap-3">
      <div className="flex flex-col">
        <h1 className="text-lg font-semibold">Ayuda</h1>
        <p className="text-xs text-muted-foreground">
          Información sobre cómo utilizar la plataforma
        </p>
      </div>

      <Separator />

      <div className="space-y-6">
        <div>
          <h2 className="text-md font-semibold mb-2">Formato de Archivos</h2>
          <p className="text-sm">
            Para utilizar nuestros servicios, necesitará cargar archivos Excel
            (.xlsx o .xls) con un formato específico. Cada tipo de reporte
            requiere una estructura particular:
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold mb-1">Ruido Dosis</h3>
          <p className="text-sm mb-2">
            El archivo debe contener las siguientes hojas:
          </p>
          <ul className="list-disc pl-6 text-sm space-y-1">
            <li>
              <strong>evaluaciones</strong>: Contiene los datos de las
              mediciones de ruido
            </li>
            <li>
              <strong>grupos de exposición</strong>: Información sobre los
              grupos de trabajadores
            </li>
            <li>
              <strong>portada</strong> (opcional): Contiene los datos de la
              portada
            </li>
            <li>
              <strong>reconocimientos</strong> (opcional): Detalles sobre el
              reconocimiento del sitio
            </li>
          </ul>
          <div className="mt-2">
            <a
              href="/excel-templates/noise-dose/Bernardino_Plantilla_Ruido_Dosis.xlsx"
              download
            >
              <Button size="sm" className="gap-2">
                <Download className="size-4" /> Descargar plantilla (.xlsx)
              </Button>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold mb-1">Iluminación</h3>
          <p className="text-sm mb-2">
            El archivo debe contener las siguientes hojas:
          </p>
          <ul className="list-disc pl-6 text-sm space-y-1">
            <li>
              <strong>evaluaciones</strong>: Contiene los datos de las
              mediciones de iluminación
            </li>
            <li>
              <strong>portada</strong> (opcional): Contiene los datos de la
              portada
            </li>

            <li>
              <strong>reconocimientos</strong> (opcional): Detalles sobre el
              reconocimiento del sitio
            </li>
            <li>
              <strong>grupos de exposición</strong> (opcional): Información
              sobre los grupos de trabajadores
            </li>
            <li>
              <strong>equipos</strong> (opcional): Información sobre los equipos
              de iluminación
            </li>
            <li>
              <strong>correcciones</strong> (opcional): Correcciones de los
              equipos de iluminación
            </li>
          </ul>
          <div className="mt-2">
            <a
              href="/excel-templates/lighting/Bernardino_Plantilla_Iluminacion.xlsx"
              download
            >
              <Button size="sm" className="gap-2">
                <Download className="size-4" /> Descargar plantilla (.xlsx)
              </Button>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold mb-1">Temperatura</h3>
          <p className="text-sm mb-2">
            El archivo debe contener las siguientes hojas:
          </p>
          <ul className="list-disc pl-6 text-sm space-y-1">
            <li>
              <strong>evaluaciones</strong>: Contiene los datos de las
              mediciones de temperatura
            </li>
            <li>
              <strong>grupos de exposición</strong>: Información sobre los
              grupos de trabajadores
            </li>
            <li>
              <strong>portada</strong> (opcional): Contiene los datos de la
              portada
            </li>
            <li>
              <strong>fuentes termicas</strong> (opcional): Información sobre
              las fuentes térmicas
            </li>
            <li>
              <strong>temperatura corporal</strong> (opcional): Información
              sobre la temperatura corporal
            </li>
          </ul>
          <div className="mt-2">
            <a
              href="/excel-templates/temperature/Bernardino_Plantilla_TGBH.xlsx"
              download
            >
              <Button size="sm" className="gap-2">
                <Download className="size-4" /> Descargar plantilla (.xlsx)
              </Button>
            </a>
          </div>
        </div>

        <Separator />

        <div>
          <h2 className="text-md font-semibold mb-2">Solución de Problemas</h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-semibold mb-1">
                El archivo no se carga correctamente
              </h3>
              <p className="text-sm">
                Asegúrese de que su archivo Excel tenga el formato correcto y
                contenga las hojas requeridas. Verifique que los nombres de las
                hojas sean exactamente como se especifica en las plantillas.
              </p>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-1">
                Error en la generación del reporte
              </h3>
              <p className="text-sm">
                Si recibe un error al generar el reporte, verifique que todos
                los datos en su archivo Excel estén completos y en el formato
                correcto. Los campos obligatorios deben estar llenos y con el
                tipo de dato adecuado.
              </p>
            </div>
          </div>
        </div>

        <Separator />

        <div>
          <h2 className="text-md font-semibold mb-2">Contacto</h2>
          <p className="text-sm mb-4">
            Si necesita ayuda adicional, no dude en contactarnos:
          </p>
          <div className="space-y-2">
            <p className="text-sm flex items-center gap-2">
              <Mail className="size-4" />{" "}
              <span className="text-muted-foreground hover:underline">
                soporte@bdino.app
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
